import {type TranslationObject} from '@colonist/i18n'
import {UIPatchNotes} from '../../../../shared/scripts/patch_notes/UIPatchNotes.ts'
import {UICheckoutPageController} from '../../../../shared/scripts/ui_checkout/UICheckoutPageController.ts'
import {UIMFullscreenPageView} from '../../ui_page/UIMFullscreenPageView.ts'
import {UIChampionship25Controller} from '../../../../shared/scripts/ui_cc/UIChampionship25Controller.ts'
import {HelplyLoader} from '../../../../shared/scripts/HelplyLoader.ts'

export class UIMSingletonPageView extends UIMFullscreenPageView {
    readonly pathname: string

    constructor(pathname: string, backButtonAction?: () => void) {
        super(UIMSingletonPageView.getTitleFromPageType(pathname), pathname, backButtonAction)
        this.pathname = pathname
        this.addQueryParameters()
    }

    static getTitleFromPageType(pathname: string): TranslationObject {
        if(pathname.includes('/faq')) return {key: 'strings:homePage.footer.faq'}
        if(pathname.includes('/terms')) return {key: 'strings:homePage.singletonPages.terms'}
        if(pathname.includes('/about')) return {key: 'strings:homePage.footer.about'}
        if(pathname.includes('/careers')) return {key: 'strings:homePage.footer.careers'}
        if(pathname.includes('/values-examples')) return {key: 'strings:homePage.singletonPages.valuesExamples'}
        if(pathname.includes('/values')) return {key: 'strings:homePage.singletonPages.values'}
        if(pathname.includes('/checkout')) return {key: 'strings:homePage.singletonPages.checkout'}
        if(pathname.includes('/community')) return {key: 'strings:homePage.footer.community'}
        if(pathname.includes('/patch-notes')) return {key: 'strings:homePage.singletonPages.patchNotes'}
        if(pathname.includes('/press-kit')) return {key: 'strings:homePage.singletonPages.pressKit'}
        if(pathname.includes('/refund-policy')) return {key: 'strings:homePage.singletonPages.refundPolicy'}
        if(pathname.includes('/privacy-policy')) return {key: 'strings:homePage.singletonPages.privacyPolicy'}
        if(pathname.includes('/championship2025')) return {key: 'strings:homePage.footer.championship25'}
        if(pathname.includes('/championship2026')) return {key: 'strings:homePage.footer.championship26'}
        return {key: 'strings:colonistCommon.utils.emptyString'}
    }

    buildView() {
        void this.setContent()
    }

    private async setContent() {
        const url = `/singleton${this.pathname}`
        const response = await fetch(url)
        const content = await response.text()
        // eslint-disable-next-line no-restricted-syntax
        this.body.innerHTML = content
        this.loadController()
    }

    removeFromDOM() {
        HelplyLoader.hide()
        super.removeFromDOM()
    }

    private addQueryParameters() {
        const url = window.location.origin + this.pathname
        const parsedUrl = new URL(url)

        window.history.pushState(undefined, '', parsedUrl.search)
    }

    private loadController() {
        if(this.pathname.includes('/checkout')) {
            new UICheckoutPageController()
        } else if(this.pathname.includes('/patch-notes')) {
            new UIPatchNotes(null)
        } else if(this.pathname.includes('/championship2025')) {
            new UIChampionship25Controller()
        } else if(this.pathname.includes('/championship2026-form')) {
            this.loadHubSpotForm()
        } else if(this.pathname.includes('/faq')) {
            HelplyLoader.initForFaqPage()
        }
    }

    private loadHubSpotForm() {
        const formIds: Record<string, string> = {
            /* eslint-disable @typescript-eslint/naming-convention */
            '/championship2026-form-application': '4f1ab7b8-d3a1-4b8d-a876-563fe037f76b',
            '/championship2026-form-announcement': '4219de75-89e3-48e5-8b62-d9ac685d241f',
            '/championship2026-form-result': 'a029ec73-d113-4ae5-8990-feb9fbc1c885',
            /* eslint-enable @typescript-eslint/naming-convention */
        }

        const formId = Object.entries(formIds).find(([route]) => this.pathname.includes(route))?.[1]
        if(!formId) return

        const createForm = () => {
            (window as any).hbspt.forms.create({
                region: 'eu1',
                portalId: '146823366',
                formId: formId,
                target: `#hs-form-container`,
            })
        }

        if((window as any).hbspt != undefined) {
            createForm()
        } else {
            const script = document.createElement('script')
            script.charset = 'utf-8'
            script.src = 'https://js-eu1.hsforms.net/forms/embed/v2.js'
            script.onload = createForm
            document.head.appendChild(script)
        }
    }
}
